import React from 'react';
import './GallerySection.css';
import { Link } from 'react-router-dom';

const GallerySection = () => {

  const galleryImages = [
    {
      id: 1,
      src: "/gal8.jpg",
      alt: "Event",
      category: "Gather & dine Events"
    },
    {
      id: 2,
      src: "/gal7.jpg",
      alt: "Event",
      category: "Ring Ceremony"
    },
    {
      id: 3,
      src: "/gal1.jpg",
      alt: "Wedding Events",
      category: "Traditional Wedding Setup"
    }
  ];

  return (
    <section className="gallery-section">
 
 <div className="background-elements">
        <div className="floating-element element-1"></div>
        <div className="floating-element element-2"></div>
        <div className="floating-element element-3"></div>
        
      </div>
      <div className="gallery-wrapper">
        {/* Gallery Title */}
        <div className="gallery-title-section">
          <h2 className="gallery-title">Gallery</h2>
        </div>

        {/* Image Grid */}
        <div className="gallery-grid">
          {galleryImages.map((image) => (
            <div key={image.id} className="gallery-card">
              <img
                src={image.src}
                alt={image.alt}
                className="gallery-image"
              />
              
              {/* Overlay */}
              <div className="gallery-overlay">
                <div className="overlay-content">
                  <h3 className="overlay-title">{image.category}</h3>
                  <p className="overlay-text">{image.alt}</p>
                </div>
              </div>
            </div>
          ))}
        </div>


        <div className="button-container">
     <Link to="/gallery" className="load-more-btn">LOAD MORE</Link>
        </div>
      </div>

    </section>
  );
};

export default GallerySection;